<template>
  <div class="main">
    <div class="content">
      <div class="address1">{{ $cookie.get('companyName')=='null'?'':$cookie.get('companyName') }}</div>
      <div class="address2">
        <div>全部地址</div>
        <el-button type="primary" @click="address">添加地址</el-button>
      </div>
      <el-table :data="tableData" class="table">
        <el-table-column prop="address" label="地址" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="区域">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.cityName }}</span>
              <span>{{ scope.row.areaName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <div style="height: 30px;line-height: 30px;">
              <span @click="edit(scope.row)" style="color: #0051AA;cursor: pointer;">
                编辑
              </span>
              <span @click="del(scope.row.companyAddressId)" style="color: #0051AA;cursor: pointer;">
                删除
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog inline :visible.sync="show" @close="closeDialog">
      <template slot="title">
        <div class="title">
          <span>{{ title }}</span>
          <span>请填写真实地址，若查实造假，账号将被冻结。</span>
        </div>
      </template>
      <div class="dialog">
        <el-form :model="form" class="form1" ref="form" label-width="70px">
          <el-form-item label="工作城市">
            <el-cascader v-model="region" :options="regionTreeList" :props="{ value: 'label' }" @change="changeRegion"
              style="width: 100%;" />
          </el-form-item>
          <!-- <el-form-item label="工作地点">
            <el-input v-model="form.address" placeholder="请选择工作地点"></el-input>
          </el-form-item> -->
          <el-form-item label="详细地址">
            <el-input v-model="form.address" placeholder="请输入详细地址" @focus="setAddress"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="show1" class="mapDialog">
      <iframe id="mapPage" width="100%" height="500px" frameborder=0
      :src="`https://apis.map.qq.com/tools/locpicker?coord=${coord}?search=1&type=1&key=RGEBZ-ARFKN-7NRF5-SNH73-OUVK3-KEBE7&referer=刘湾零工市场'`"">
      </iframe>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      addressDetail: {},
      title: '',
      show: false,
      show1: false,
      form: {
        provinceName: '',
        cityName: '',
        areaName: '',
        address: '',
        longitude: '',
        latitude: ''
      },
      regionTreeList: [],
      region: '',
      submitType: 0,
      coord:''
    }
  },
  mounted() {
    this.getCompanyAddressList()
    this.selectRegionTreeList()
    let that = this
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;
      if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        // console.log('location', loc);
        that.form.longitude = loc.latlng.lng
        that.form.latitude = loc.latlng.lat
        that.form.address = loc.poiname
        that.show1 = false
      }
    }, false);
  },
  methods: {
    closeDialog() {
      this.coord = ''
      this.region = ''
      this.$refs.form.resetFields()
    },

    setAddress() {
      if (this.coord) {
      this.show1 = true
      }else{
        this.$message({
            message: '请先选择工作地点',
            type: 'warning'
          })
      }
    },
    getCompanyAddressList() {
      this.$get('/api/company/company/getCompanyAddressList', {}).then(res => {
        this.tableData = res.data
      })
    },
    async changeRegion(value) {
      this.form.provinceName = value[0]
      this.form.cityName = value[1]
      this.form.areaName = value[2]
      let addressStr = value.join('')
      let res = await this.$jsonp(
        `https://apis.map.qq.com/ws/geocoder/v1`,
        {
          address: addressStr,
          key: "OO5BZ-Z7V6L-XFDP4-MPR6O-OD2XO-QPFVO", // 你的key
          type: 1,
          output: "jsonp",
        }
      );
      if (res.status === 0) {
        this.coord = res.result.location.lat + ',' +res.result.location.lng
      }
    },
    selectRegionTreeList() {
      this.$get('/api/common/selectRegionTreeList', {}).then(res => {
        this.regionTreeList = res.data
      })
    },
    address() {
      this.title = '添加地址'
      this.show = true
      this.submitType = 0
      this.region= ''
      this.form= {
        provinceName: '',
        cityName: '',
        areaName: '',
        address: '',
        longitude: '',
        latitude: ''
      }
    },
    submit() {
      if (this.submitType == 0) {
        if (!this.form.provinceName) {
          this.$message({
            message: '未选择工作城市',
            type: 'warning'
          })
          return
        } else if (!this.form.address) {
          this.$message({
            message: '未选择详细地址',
            type: 'warning'
          })
          return
        }
        this.$post('/api/company/company/addCompanyAddress', { ...this.form }).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.getCompanyAddressList()
          this.$refs.form.resetFields()
          this.show = false
        })
      } else {
        if (!this.form.provinceName) {
          this.$message({
            message: '未选择工作城市',
            type: 'warning'
          })
          return
        } else if (!this.form.address) {
          this.$message({
            message: '未选择详细地址',
            type: 'warning'
          })
          return
        }
        this.$post('/api/company/company/editCompanyAddress', { ...this.form }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getCompanyAddressList()
          this.$refs.form.resetFields()
          this.show = false
        })
      }
    },
    edit(row) {
      this.$get('/api/company/company/getCompanyAddressDetail', { companyAddressId: row.companyAddressId }).then(res => {
       let region = []

        region[0] = res.data.provinceName?res.data.provinceName.replace('市', ''):''
        region[1] = res.data.cityName
        region[2] = res.data.areaName
        // this.$forceUpdate()
        this.coord = res.data.latitude + ',' +res.data.longitude
        this.form = res.data
        this.region = region

        this.submitType = 1
        this.show = true

      })
    },
    del(id) {
      this.$post('/api/company/company/deleteCompanyAddress', { companyAddressId: id }).then(res => {
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        this.getCompanyAddressList()
      })
    }
  }
}
</script>
<style scoped>
.main {
  padding: 30px;
}

.content {
  height: 708px;
  /* padding: 20px; */
  background: #FFFFFF;
}

.address1 {
  width: 216px;
  height: 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.address2 {
  padding-right: 50px;
  display: flex;
  justify-content: space-between;
}

.address2>div:nth-of-type(1) {
  width: 72px;
  height: 30px;
  font-weight: bold;
  font-size: 18px;
  color: #0051AA;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.table {
  margin-top: 20px;
}

.title>span:nth-of-type(1) {
  height: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.title>span:nth-of-type(2) {
  height: 24px;
  padding-left: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

::v-deep .el-dialog {
  width: 800px;
}
</style>